const ROLE_ALIASES = {
  ADMIN: ["ROLE_ADMIN", "ADMIN", "ROLE_ADMINISTRADOR"],
  ADMIN_PLANIFICADOR: ["ROLE_ADMIN_PLANIFICADOR", "ADMIN_PLANIFICADOR"],
  COORDINADOR: [
    "ROLE_COORDINADOR_VENDEDOR",
    "COORDINADOR_VENDEDOR",
    "ROLE_COORDINADOR",
    "ROLE_COORDINADOR_MAYORISTA",
    "COORDINADOR_MAYORISTA",
    "ROLE_COORDINADOR_SIN_CANAL",
    "COORDINADOR_SIN_CANAL",
  ],
  VENDEDOR: [
    "ROLE_VENDEDOR_PLANIFICADOR",
    "VENDEDOR_PLANIFICADOR",
    "ROLE_VENDEDOR",
    "ROLE_VENDEDOR_RETAIL",
    "VENDEDOR_RETAIL",
    "ROLE_VENDEDOR_MAYORISTA",
    "VENDEDOR_MAYORISTA",
  ],
  COORDINADOR_MAYORISTA: ["ROLE_COORDINADOR_MAYORISTA", "COORDINADOR_MAYORISTA"],
  COORDINADOR_SIN_CANAL: ["ROLE_COORDINADOR_SIN_CANAL", "COORDINADOR_SIN_CANAL"],
  VENDEDOR_RETAIL: ["ROLE_VENDEDOR_RETAIL", "VENDEDOR_RETAIL"],
  VENDEDOR_MAYORISTA: ["ROLE_VENDEDOR_MAYORISTA", "VENDEDOR_MAYORISTA"],
};


export const EMPRESA_SSO = {
  DINAR: 5,
  SACK: 6,
};

export const getEmpresaActiva = () =>
  Number(sessionStorage.getItem("empresaActiva")) || null;

export const isEmpresaDinar = () => getEmpresaActiva() === EMPRESA_SSO.DINAR;
export const isEmpresaSack = () => getEmpresaActiva() === EMPRESA_SSO.SACK;

export const getRoles = () => {
  try {
    const raw = sessionStorage.getItem("roles");
    const parsed = raw ? JSON.parse(raw) : [];
    if (Array.isArray(parsed) && parsed.length) return parsed;
  } catch (_) {}

  const authority = sessionStorage.getItem("authority");
  return authority ? [authority] : [];
};

export const getPerfilActual = () =>
  String(sessionStorage.getItem("perfil") || "").toUpperCase();

export const hasRole = (...roleGroups) => {
  const roles = getRoles();
  return roleGroups.some((group) =>
    (ROLE_ALIASES[group] || [group]).some((role) => roles.includes(role)),
  );
};

export const isAdmin = () => hasRole("ADMIN");
export const isVendedor = () => hasRole("VENDEDOR");
export const isCoordinador = () => hasRole("COORDINADOR");
export const canManageUsers = () => hasRole("ADMIN", "ADMIN_PLANIFICADOR");
export const canDeleteUsers = () => isAdmin();
export const canSynchronize = () =>
  hasRole("ADMIN", "ADMIN_PLANIFICADOR", "COORDINADOR", "VENDEDOR");
export const canUsePlanificador = () =>
  hasRole("ADMIN", "ADMIN_PLANIFICADOR", "COORDINADOR", "VENDEDOR");

export const canAccessSackBoleta = () =>
  isEmpresaSack() &&
  hasRole(
    "ADMIN",
    "ADMIN_PLANIFICADOR",
    "COORDINADOR_SIN_CANAL",
    "VENDEDOR_RETAIL",
  );

export const canAccessSackFactura = () =>
  isEmpresaSack() &&
  hasRole(
    "ADMIN",
    "ADMIN_PLANIFICADOR",
    "COORDINADOR_MAYORISTA",
    "COORDINADOR_SIN_CANAL",
    "VENDEDOR_RETAIL",
    "VENDEDOR_MAYORISTA",
  );

export const canAccessDinarNotaVenta = () =>
  isEmpresaDinar() &&
  hasRole("ADMIN", "ADMIN_PLANIFICADOR", "COORDINADOR", "VENDEDOR");

export const canAccessDinarReports = () =>
  isEmpresaDinar() &&
  hasRole("ADMIN", "ADMIN_PLANIFICADOR", "COORDINADOR", "VENDEDOR");

export const canCreateClient = (brand) => {
  const currentBrand = String(brand || "").toLowerCase();
  if (currentBrand === "dinar") return false;
  if (currentBrand !== "sack" || !isEmpresaSack()) return false;
  return !hasRole("COORDINADOR_MAYORISTA", "COORDINADOR_SIN_CANAL");
};

export const canAccessRoute = (pathname) => {
  if (pathname === "/sincronizacion") return true;
  if (!canUsePlanificador()) return false;
  if (pathname === "/usuarios") return canManageUsers();
  if (pathname === "/sincronizar") return canSynchronize();
  if (pathname === "/boleta") return canAccessSackBoleta();
  if (pathname === "/factura") return canAccessSackFactura();
  if (pathname === "/nota-venta") return canAccessDinarNotaVenta();
  if (pathname === "/reporte-tiempo-respuesta") {
    return canAccessDinarReports();
  }
  if (["/reporte-nota-venta", "/reporte-no-confirmados"].includes(pathname)) {
    return canAccessDinarReports() && !isVendedor();
  }

  return true;
};

export const hasPermiso = (menuKey, accionKey) => {
  try {
    const raw = sessionStorage.getItem("permisos");
    if (!raw) return false;
    const permisosArr = JSON.parse(raw);
    if (!Array.isArray(permisosArr)) return false;

    return permisosArr.some((entry) => {
      const menu = entry?.[menuKey];
      if (!menu) return false;
      const acciones = menu.ACCIONES;
      if (Array.isArray(acciones)) return acciones.includes(accionKey);
      if (typeof acciones !== "string") return false;
      try {
        const parsed = JSON.parse(acciones);
        if (Array.isArray(parsed)) return parsed.includes(accionKey);
      } catch (_) {}
      return acciones
        .split(",")
        .map((value) => value.trim())
        .includes(accionKey);
    });
  } catch (_) {
    return false;
  }
};
